import React from "react";

// Marketing label badges shown in the catalogue + admin product cards.
const STYLES = {
  "Terlaris": "bg-[hsl(var(--warning))]/15 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/30",
  "Baru": "bg-primary/10 text-primary border-primary/25",
  "Promo": "bg-destructive/10 text-destructive border-destructive/25",
  "Stok Terbatas": "bg-secondary text-secondary-foreground border-border",
};

export function LabelBadges({ labels = [], className = "" }) {
  const list = (labels || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {list.map((l) => (
        <span key={l} data-testid="product-label-badge"
          className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full border ${STYLES[l] || "bg-secondary text-secondary-foreground border-border"}`}>
          {l}
        </span>
      ))}
    </div>
  );
}
